import React from 'react';
import { motion } from 'framer-motion';

const CaseCard = ({ caseStudy, onClick, index = 0, showDescription = true }) => {
    return (
        <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5, delay: index * 0.1 }}
            className="group cursor-pointer"
            onClick={onClick}
        >
            {/* Card */}
            <div className="bg-[#111111] rounded-2xl overflow-hidden group-hover:bg-[#1a1a1a] transition-all duration-300 relative border border-white/5 hover:border-white/10">
                {/* Image Container */}
                <div className="relative aspect-[4/3] overflow-hidden bg-gradient-to-br from-gray-800 to-gray-900">
                    <img
                        src={caseStudy.screenshot || caseStudy.screenshotHome}
                        alt={`${caseStudy.title} screenshot`}
                        className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                        loading="lazy"
                        onError={(e) => {
                            e.target.style.display = 'none';
                            e.target.parentElement.innerHTML = `
                <div class="w-full h-full flex items-center justify-center bg-gradient-to-br from-gray-800 to-gray-900">
                  <div class="text-center p-8">
                    <div class="text-6xl mb-4">📱</div>
                    <p class="text-white font-bold text-xl">${caseStudy.title}</p>
                    <p class="text-gray-400 text-sm mt-2">${caseStudy.category}</p>
                  </div>
                </div>
              `;
                        }}
                    />

                    {/* Arrow Icon - Top Right */}
                    <div className="absolute top-4 right-4">
                        <div className="w-10 h-10 bg-white/10 backdrop-blur-sm rounded-full flex items-center justify-center group-hover:bg-white/20 transition-all duration-300">
                            <svg className="w-5 h-5 text-white transform -rotate-45" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 8l4 4m0 0l-4 4m4-4H3" />
                            </svg>
                        </div>
                    </div>
                </div>

                {/* Content */}
                <div className="p-6">
                    {/* Category Badge */}
                    <p className="text-white/50 text-xs font-bold mb-3 uppercase tracking-widest">
                        {caseStudy.category}
                    </p>

                    {/* Title */}
                    <h3 className="text-2xl font-bold text-white mb-3 group-hover:text-white/90 transition-colors duration-300">
                        {caseStudy.title}
                    </h3>

                    {/* Tags */}
                    <div className="flex gap-2 flex-wrap mb-4">
                        {caseStudy.tags.slice(0, 3).map((tag, tagIndex) => (
                            <span
                                key={tagIndex}
                                className="px-3 py-1 bg-white/10 backdrop-blur-sm text-white/80 text-xs font-bold rounded-full"
                            >
                                {tag}
                            </span>
                        ))}
                    </div>

                    {/* Description */}
                    {showDescription && (
                        <p className="text-white/60 text-sm leading-relaxed mb-4 line-clamp-3">
                            {caseStudy.description}
                        </p>
                    )}

                    {/* Metrics */}
                    <div className="flex gap-6 pt-4 border-t border-white/10">
                        {caseStudy.metrics.slice(0, 2).map((metric, metricIndex) => (
                            <div key={metricIndex} className="flex flex-col items-start">
                                <p className="text-xl font-bold text-white mb-1">{metric.value}</p>
                                <p className="text-white/50 text-[10px] font-semibold uppercase tracking-wider">{metric.label}</p>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </motion.div>
    );
};

export default CaseCard;
